var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { neutralDay } from '@teamsparta/design-system';
var Check = function (_a) {
    var _b = _a.color, color = _b === void 0 ? neutralDay.gray50 : _b;
    return (_jsx("svg", __assign({ width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M3.33301 10L7.49967 14.1667L16.6663 5', stroke: color, strokeWidth: '1.75', strokeLinecap: 'round', strokeLinejoin: 'round' }) })));
};
export default Check;
//# sourceMappingURL=Check.js.map